module.exports = __webpack_public_path__ + "static/media/p0_1.dd26b8f3.png";